<script setup lang="ts">
import { Star } from '@lucide/vue';
import OtEquipmentIcon from './EquipmentIcon.vue';
import OtSurface from './Surface.vue';

interface Props {
    equipment: any;
    type: string;
}
defineProps<Props>();
</script>

<template>
    <div class="flex gap-2">
        <ot-equipment-icon :id="equipment.item.id" :type="type" :amount="equipment.amount" />
        <div class="flex flex-col justify-center">
            <div>
                <ot-surface type="hardcourt" />
                <star
                    v-for="i in 5"
                    :key="i"
                    class="inline text-amber-700"
                    :class="{ 'fill-amber-700': i <= equipment.item.qualityHardcourt / 30 }"
                />
            </div>
            <div>
                <ot-surface type="clay" />
                <star
                    v-for="i in 5"
                    :key="i"
                    class="inline text-amber-700"
                    :class="{ 'fill-amber-700': i <= equipment.item.qualityClay / 30 }"
                />
            </div>
        </div>
        <div class="flex flex-col justify-center">
            <div>
                <ot-surface type="gras" />
                <star
                    v-for="i in 5"
                    :key="i"
                    class="inline text-amber-700"
                    :class="{ 'fill-amber-700': i <= equipment.item.qualityGrass / 30 }"
                />
            </div>
            <div>
                <ot-surface type="carpet" />
                <star
                    v-for="i in 5"
                    :key="i"
                    class="inline text-amber-700"
                    :class="{ 'fill-amber-700': i <= equipment.item.qualityCarpet / 30 }"
                />
            </div>
        </div>
        <div class="flex flex-col justify-center">{{ equipment.item.brand.name }} {{ equipment.item.name }}</div>
    </div>
</template>
